import gql from 'graphql-tag';

export const SEND_PUSH_NOTIFICATIONS = gql`
  mutation SendPushNotifications($projectId: String!, $title: String!, $content: String!, $topic: String!) {
    notification {
      sendPushNotifications(projectId: $projectId, title: $title, content: $content, topic: $topic)
    }
  }
`;
